import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useAppSelector } from 'redux/store';

const LoggedInUser = () => {
  const username = useAppSelector((state) => state.auth.userData.username);

  return (
    <OverlayTrigger
      placement="bottom"
      overlay={
        <Tooltip id="user-tooltip" style={{ position: 'fixed' }}>
          Logged in as {username}
        </Tooltip>
      }
    >
      <div className="fw-bolder" style={{ cursor: 'default' }}>
        {username}
      </div>
    </OverlayTrigger>
  );
};

export default LoggedInUser;
